const isExactMatch = (str, pattern) => {
    if (typeof str !== 'string' || typeof pattern !== 'string') {
        return false;
    }
    return str.includes(pattern);
};

export default isExactMatch;